import React from 'react';
import { styled } from 'styled-components';
const SMS = (props) => {
    const { sms } = props;
    const textParts = sms.text.split('\n');
    return (React.createElement(SMSStyled, { style: props.style },
        sms.from && (React.createElement("div", { className: "from" },
            React.createElement("span", null, "From"),
            sms.from)),
        sms.number && (React.createElement("div", { className: "to" },
            React.createElement("span", null, "To"),
            "+",
            sms.countryCode,
            " ",
            sms.number)),
        React.createElement("div", { className: "body" }, textParts &&
            textParts.map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                item,
                index !== textParts.length - 1 && React.createElement("br", null)))))));
};
export default SMS;
const SMSStyled = styled.div `
  background: #fff;
  .from,
  .to,
  .body {
    border-bottom: 1px solid lightgrey;
    padding: 10px 15px;
  }
  .from > span:first-child,
  .to > span:first-child {
    width: 55px;
    opacity: 0.6;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    font-size: 0.75em;
  }
  .from > span:first-child:after,
  .to > span:first-child:after {
    content: ': ';
  }
  .body pre {
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .subject {
    font-weight: bold;
  }
  .date {
    float: right;
    color: lightgrey;
  }
  .email {
    padding: 20px;
  }
  border: 1px solid lightgrey;
  border-bottom: none;
`;
//# sourceMappingURL=SMS.js.map